<template>
  <div class="homeContent">

    <!-- banner图 -->
    <!-- <div class="head_box">
      <el-carousel indicator-position="outside" height="520px">
        <el-carousel-item v-for="(item, index) in bannerList" :key="index">
          <img :src="item.imgUrl" alt="" style="object-fit: cover;width: 100%;height: 100%;" />
        </el-carousel-item>
      </el-carousel>
    </div> -->
    <div class="aboutFurui">
      <!-- <div class="about_one">
        <div class="blue_piece"></div>
        <p>{{ $t("user.aboustus") }}</p>
      </div> -->
      <!-- <div class="about_two">{{ $t("user.Chongqing") }}</div>
      <div>{{ $t("user.text1") }}</div> -->
      <!-- <div class="about_three"></div>
      <div class="about_four">
        {{ $t("user.chongqingcontent2") }}
      </div> -->
    </div>
    <div class="home_three">
      <!-- 公司介绍 -->
      <div class="three_content" style="padding: 0 3vw 0 3vw;"
        :style="{ paddingLeft: $i18n.locale === 'en' ? '3vw' : '3vw' }">
        <el-row :gutter="0">
          <el-col :xs="24" :sm="12">
            <div class="ht_left" :style="{ width: $i18n.locale === 'en' ? '43vw' : '' }">
              <div class="about_two">{{ $t("user.Chongqing") }}</div>
              <div style="margin-bottom: 10px;font-size: 18px;text-align: justify;">{{ $t("user.text1") }}
              </div>
              <div style="margin-bottom: 10px;font-size: 18px;text-align: justify;">{{ $t("user.homesynopsis")
              }}</div>
              <div style="margin-bottom: 10px;font-size: 18px;text-align: justify;">{{ $t("user.chongqingcontent2") }}
              </div>
              <div style="margin-bottom: 10px;font-size: 18px;text-align: justify;">{{ $t("user.chongqingcontent14")
              }}
              </div>
              <div style="font-size: 18px;text-align: justify;">{{ $t("user.companySimple") }}</div>
              <!-- <div class="heng_line"></div>
              <div class="start_year"><span class="es_font">2025</span>年</div>
              <div>{{ $t("user.chongqingcontent4") }}</div>
              <div class="heng_line"></div>
              <div><span class="es_font" style="font-size: 23px;">传统家电、3C产品、家居建材等商品;</span></div> -->
            </div>
          </el-col>
          <el-col :xs="24" :sm="12">
            <div class="ht_right">
              <img src="../assets/furuiImg/公司简介-图.jpg" width="100%">
              <!-- <video width="100%" height="" autoplay controls>
              <source src="../assets/furuiImg/006.mp4" type="video/mp4" />
              Your browser does not support the video tag.
              </video> -->
            </div>
          </el-col>
        </el-row>

      </div>
      <!-- 数字排布 -->
      <div style="width: 100%; height: 170px; position: relative;
										overflow: hidden;padding: 0 3vw;
									">
        <!-- 背景图 - 新增object-position: bottom控制显示下半部分 -->
        <img src="@/assets/image/公司简介-背景图.png" alt="公司简介背景图" style="
											position: absolute;
											top: 0;
											left: 0;
											width: 0;
											/* height: 40%; */
											object-fit: cover;
											object-position: center bottom; /* 关键：图片底部对齐容器底部 */
										">

        <!-- 上层内容 -->
        <div style="
											position: relative;
											color: black; 
											display: flex;flex-direction: row;align-items: center;justify-content: space-between;height: 100%;background-color: transparent;
										">
          <div style="border-left: 2px solid #CFCFCF;padding-left: 10px;width: 100%;text-align: center;">
            <p style="font-size: 30px;color: #56B275;">2000</p>
            <p>{{ $t("user.home1") }}</p>
          </div>
          <div style="border-left: 2px solid #CFCFCF;padding-left: 10px;width: 100%;text-align: center;">
            <p style="font-size: 30px;color: #56B275;">300</p>
            <p>{{ $t("user.home2") }}</p>
          </div>
          <div style="border-left: 2px solid #CFCFCF;padding-left: 10px;width: 100%;text-align: center;">
            <p style="font-size: 30px;color: #56B275;">7</p>
            <p>{{ $t("user.home3") }}</p>
          </div>
          <div style="border-left: 2px solid #CFCFCF;padding-left: 10px;width: 100%;text-align: center;">
            <p style="font-size: 30px;color: #56B275;">35</p>
            <p>{{ $t("user.home4") }}</p>
          </div>
          <div style="border-left: 2px solid #CFCFCF;padding-left: 10px;width: 100%;text-align: center;">
            <p style="font-size: 30px;color: #56B275;">3000+</p>
            <p>{{ $t("user.home5") }}</p>
          </div>
          <!-- <div style="border-left: 2px solid #CFCFCF;padding-left: 10px;width: 100%;text-align: center;">
            <p style="font-size: 30px;color: #56B275;">1500</p>
            <p>{{ $t("user.home7") }}</p>
          </div> -->
        </div>
      </div>
    </div>
    <!-- 选择产品 -->
    <div style="width: 100%; background-color: #56B275; height: 100px;padding: 0 3vw;">
      <ul
        style="display: flex; flex-direction: row; height: 100px; justify-content: space-between;  list-style: none; margin: 0;">
        <!-- 循环渲染选项，减少重复代码 -->
        <li v-for="(item, index) in items" :key="index"
          style="width: 130px; justify-content: center; align-items: center; display: flex; flex-direction: column; cursor: pointer;"
          :style="{
            backgroundColor: activeIndex === index ? '#FFFFFF' : 'transparent',
            color: activeIndex === index ? '#56B275' : '#fff'
          }" @click="handleClick(index, item)">
          <p :style="{
            fontSize: $i18n.locale === 'en' ? '16px' : '24px'
          }">
            {{ item.name }}
          </p>
          <p style="font-size: 14px; margin: 5px 0 0 0;">{{ $t("user.workcenter") }}</p>
        </li>
      </ul>
    </div>

    <!-- 产品布置 -->
    <div v-loading="isLoading" element-loading-text="加载中，请稍候..." element-loading-spinner-color="#56B275"
      element-loading-background="rgba(255, 255, 255, 0.8)" style="position: relative;">
      <div
        style="display: flex;flex-direction: row;justify-content: center;flex-wrap: wrap;padding:0 3vw;gap: 20px;margin-top: 25px;">
        <!-- 使用v-for循环渲染产品卡片 -->
        <div v-for="(product, index) in products.slice(0, 5)" :key="index" class="product_card">
          <div>
            <p style=" border-left: 1vw solid #56B275;font-size: 1.1vw;padding-left: 1vw;height: 2vw;white-space: nowrap;"
              :style="{ marginBottom: $i18n.locale === 'en' ? '30px' : '' }">
              {{ product.name }}
            </p>
            <div class="product_p1"></div>
            <div class="product_p2"></div>
            <!-- <img :src="product.viewpic" :alt="product.title" style="width: 13vw;height: 18vw;"> -->
            <el-image :src="product.viewpic" lazy style="width: 15vw;height: 18vw;"></el-image>
            <div @click="gotoDetail(product)" class="product_btn">
              点击查看</div>
          </div>
        </div>
        <div style="width: 100%;height: 100%;display: flex;justify-content: flex-end;">
          <div class="more" @click="handleMore">查看更多</div>
        </div>
      </div>
    </div>
    <div class="home_last">
      <!-- 四方块 -->
      <div style="display: flex;justify-content: space-between;padding: 0 3vw;">
        <!-- <img src="@/assets/picture/图1.png" alt="" style="width: 47vw;margin-bottom: 100px;"> -->
        <div
          style="width: 47vw;margin-bottom: 100px;height: 40vw;display: flex;flex-direction: column;gap: 0;cursor: pointer;">
          <!-- <div style="display: flex;flex-direction: row;width: 100%;height: 33.3%;gap: 0;"> -->
          <!-- <div style="background-color: black;width: 50%;overflow: hidden;">
              <img src="@/assets/picture/1.png" alt="" style="width: 100%; height: 100%; object-fit: fit;"
                @click="openImage('@/assets/picture/1.png')">
            </div>
            <div style="background-color: blue;width: 50%;overflow: hidden;">
              <img src="@/assets/picture/2.png" alt="" style="width: 100%; height: 100%; object-fit: fit;"
                @click="openImage('@/assets/picture/2.png')">
            </div>
          </div>
          <div style="display: flex;flex-direction: row;width: 100%;height: 33.3%;gap: 0;">
            <div style="background-color: black;width: 50%;overflow: hidden;">
              <img src="@/assets/picture/3.png" alt="" style="width: 100%; height: 100%; object-fit: fit;"
                @click="openImage('@/assets/picture/3.png')">
            </div>
            <div style="background-color: blue;width: 50%;overflow: hidden;">
              <img src="@/assets/picture/6.png" alt="" style="width: 100%; height: 100%; object-fit: fit;"
                @click="openImage('@/assets/picture/6.png')">
            </div>
          </div>
          <div style="display: flex;flex-direction: row;width: 100%;height: 33.3%;">
            <div style="background-color: pink;width: 50%;overflow: hidden;">
              <img src="@/assets/picture/5.png" alt="" style="width: 100%; height: 100%; object-fit: fit;"
                @click="openImage('@/assets/picture/5.png')">
            </div>
            <div style="background-color: purple;width: 50%;overflow: hidden;">
              <img src="@/assets/picture/4.png" alt="" style="width: 100%; height: 100%; object-fit: fit;"
                @click="openImage('@/assets/picture/4.png')">
            </div>
          </div> -->
          <div v-for="(row, rowIndex) in imageRows" :key="rowIndex"
            style="display: flex; flex-direction: row; width: 100%; height: 33.3%; gap: 0;">
            <!-- 循环每行的2张图片 -->
            <div v-for="(item, colIndex) in row" :key="colIndex"
              :style="{ backgroundColor: item.bgColor, width: '50%', overflow: 'hidden' }">
              <!-- <img :src="item.src" alt="" style="width: 100%; height: 100%; object-fit: fit; cursor: pointer;"
                @click="openImage(item.src)"> -->
              <el-image :src="item.src" alt="" style="width: 100%; height: 100%; object-fit: fit;"
                :preview-src-list="[item.src]">
              </el-image>
            </div>
          </div>
        </div>
        <!-- <img src="@/assets/picture/图2.png" alt="" style="width: 45vw;margin-bottom: 5px;margin-right: 35px;"> -->
        <div style="width: 47vw;background-color: #56B275;margin-bottom: 100px;display: flex;flex-direction: row;">
          <div style="display: flex;flex-direction: column;width: 100%;height: 100%;">
            <!-- @click="goAboutUs" -->
            <div class="fourpic">
              <svg t="1753432544274" class="icon" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="1536" width="52" height="52">
                <path
                  d="M855.04 1016.604444H169.301333c-8.760889 0-15.928889-7.168-15.928889-15.928888V948.906667c0-50.176 40.618667-90.680889 90.680889-90.680889h535.438223c50.176 0 90.680889 40.618667 90.680888 90.680889v51.768889c0.796444 8.760889-6.371556 15.928889-15.132444 15.928888z m-669.809778-31.857777h653.198222V948.906667c0-32.654222-26.282667-58.823111-58.823111-58.823111H244.053333c-32.654222 0-58.823111 26.282667-58.823111 58.823111v35.84z m213.219556-445.553778c-3.185778 0-7.168-0.796444-10.353778-3.185778l-56.433778-45.397333c-3.185778-2.389333-5.575111-6.371556-5.575111-10.353778-0.796444-3.982222 0.796444-8.760889 3.185778-11.946667l81.123555-100.238222c5.575111-7.168 15.928889-7.964444 22.300445-2.389333l56.433778 45.397333c3.185778 2.389333 5.575111 6.371556 5.575111 10.353778 0.796444 3.982222-0.796444 8.760889-3.185778 11.946667l-80.327111 99.441777c-3.185778 3.982222-7.964444 6.371556-12.743111 6.371556z m-33.450667-64.398222l31.857778 25.486222 59.619555-73.955556-31.857777-25.486222-59.619556 73.955556z m267.264-251.448889c-3.982222 0-7.168-1.592889-10.353778-3.185778l-45.397333-36.636444c-3.185778-2.389333-5.575111-6.371556-5.575111-10.353778-0.796444-3.982222 0.796444-8.760889 3.185778-11.946667l63.601777-79.530667c5.575111-7.168 15.928889-7.964444 22.300445-2.389333L705.422222 115.939556c7.168 5.575111 7.964444 15.928889 2.389334 22.300444l-63.601778 79.530667c-2.389333 3.185778-6.371556 5.575111-10.353778 5.575111h-1.592889z m-22.300444-54.044445l19.911111 16.725334 43.804444-54.044445-19.911111-16.725333-43.804444 54.044444z m0 0"
                  fill="#56B275" p-id="1537"></path>
                <path
                  d="M721.464889 165.432889c-3.185778 0-7.168-0.796444-10.353778-3.185778l-92.273778-74.752c-3.185778-2.389333-5.575111-6.371556-5.575111-11.150222 0-3.982222 0.796444-8.760889 3.982222-11.946667l45.397334-52.565333c5.575111-6.371556 15.132444-7.168 22.300444-2.389333l92.273778 74.752c7.168 5.575111 7.964444 15.928889 2.389333 22.300444l-3.982222 4.778667-41.415111 48.583111c-3.185778 3.982222-7.964444 5.575111-12.743111 5.575111z m-69.176889-92.273778l67.584 54.840889 24.689778-28.672-67.584-54.840889-24.689778 28.672zM433.493333 724.764444H169.301333c-8.760889 0-15.928889-7.168-15.928889-15.928888v-89.884445c0-8.760889 7.168-15.928889 15.928889-15.928889h263.281778c8.760889 0 15.928889 7.168 15.928889 15.928889v89.884445c0.796444 8.760889-6.371556 15.928889-15.132444 15.928888z m-248.263111-31.857777h231.537778v-58.026667H185.230222v58.026667z m0 0"
                  fill="#56B275" p-id="1538"></path>
                <path
                  d="M769.137778 890.197333H259.185778c-5.575111 0-10.353778-3.185778-13.539556-7.964444-3.185778-4.778667-3.185778-10.353778-0.796444-15.928889l85.902222-163.84c2.389333-3.982222 5.575111-7.168 10.353778-7.964444 4.778667-0.796444 8.760889 0 12.743111 2.389333l95.459555 65.991111L639.431111 489.244444l-100.238222-80.327111c-3.185778-2.389333-5.575111-6.371556-5.575111-10.353777-0.796444-3.982222 0.796444-8.760889 3.185778-11.946667l23.096888-28.672c5.575111-6.371556 15.132444-7.964444 22.300445-2.389333 3.185778 2.389333 7.168 4.778667 13.539555 4.778666 12.743111 0 22.300444-10.353778 22.300445-22.300444 0-6.371556-3.185778-12.743111-7.964445-17.521778-6.371556-5.575111-7.168-15.132444-2.389333-22.300444l14.336-17.521778c5.575111-7.168 15.132444-7.964444 22.300445-2.389334l134.485333 105.016889c3.982222 3.185778 6.371556 7.964444 6.371555 12.743111v478.094223c0 8.760889-7.168 15.928889-15.928888 15.928889z m-483.669334-31.857777H753.208889V404.024889l-105.813333-82.716445c1.592889 4.778667 2.389333 10.353778 2.389333 15.928889 0 30.264889-24.689778 54.044444-54.044445 54.044445-6.371556 0-13.539556-1.592889-19.114666-3.982222l-4.778667 5.575111L671.288889 472.405333c6.371556 5.575111 7.964444 14.336 3.185778 21.504L466.830222 793.827556c-4.778667 7.168-15.132444 8.760889-22.300444 3.982222l-93.866667-65.194667-65.194667 125.724445z m0 0"
                  fill="#56B275" p-id="1539"></path>
                <path
                  d="M509.041778 462.165333c-3.185778 0-7.168-0.796444-10.353778-3.185777l-116.167111-94.663112c-3.185778-2.389333-5.575111-6.371556-5.575111-10.353777-0.796444-3.982222 0.796444-8.760889 3.185778-11.946667l165.432888-204.458667c5.575111-7.168 15.928889-7.964444 22.300445-2.389333l116.167111 93.866667c7.168 5.575111 7.964444 15.928889 2.389333 22.300444l-54.044444 66.787556c-2.389333 3.185778-6.371556 5.575111-11.150222 5.575111-3.982222 0.796444-8.760889-0.796444-11.946667-3.982222-3.185778-2.389333-7.964444-5.575111-14.336-5.575112-12.743111 0-22.300444 10.353778-22.300444 22.300445 0 7.168 3.185778 13.539556 8.760888 17.521778 3.185778 2.389333 5.575111 6.371556 6.371556 11.150222 0.796444 4.778667-0.796444 8.760889-3.185778 11.946667l-63.601778 78.734222c-3.185778 3.982222-7.168 6.371556-11.946666 6.371555z m-93.866667-112.184889l91.477333 73.955556 44.600889-54.840889c-6.371556-8.760889-9.557333-19.911111-9.557333-31.061333 0-30.264889 24.689778-54.044444 54.044444-54.044445 7.168 0 14.336 1.592889 21.504 4.778667l35.043556-43.804444-92.273778-75.548445-144.839111 180.565333z m0 0"
                  fill="#56B275" p-id="1540"></path>
                <path
                  d="M595.740444 392.078222c-11.946667 0-23.893333-3.982222-33.450666-11.150222a54.317511 54.317511 0 0 1-21.504-43.008c0-30.264889 24.689778-54.044444 54.044444-54.044444 12.743111 0 25.486222 4.778667 35.043556 12.743111a55.068444 55.068444 0 0 1 19.114666 41.415111c0.796444 29.468444-23.096889 54.044444-53.248 54.044444z m0-77.141333c-12.743111 0-22.300444 10.353778-22.300444 22.300444 0 7.168 3.185778 13.539556 8.760889 17.521778 3.185778 2.389333 7.168 4.778667 13.539555 4.778667 12.743111 0 22.300444-10.353778 22.300445-22.300445 0-6.371556-3.185778-12.743111-7.964445-17.521777-3.185778-2.389333-7.964444-4.778667-14.336-4.778667z m0 0M641.934222 815.331556c-38.229333 0-69.176889-31.061333-69.176889-69.176889s31.061333-69.176889 69.176889-69.176889 69.176889 31.061333 69.176889 69.176889c0.796444 38.229333-30.264889 69.176889-69.176889 69.176889z m0-123.335112c-29.468444 0-53.361778 23.893333-53.361778 53.248s23.893333 53.248 53.361778 53.248 53.248-23.893333 53.248-53.248c0.796444-29.468444-23.096889-53.248-53.248-53.248z m0 0M769.137778 945.834667H259.185778c-4.778667 0-7.964444-3.185778-7.964445-7.964445s3.185778-7.964444 7.964445-7.964444H769.137778c4.778667 0 7.964444 3.185778 7.964444 7.964444 0 3.982222-3.982222 7.964444-7.964444 7.964445z m0 0"
                  fill="#56B275" p-id="1541"></path>
              </svg>
              <p>技术实力</p>
              <p>Technical strength</p>
            </div>
            <!-- @click="goAboutUs" -->
            <div class="fourpic">
              <svg t="1753432670653" class="icon" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="1977" width="52" height="52">
                <path
                  d="M666.282667 920.462222c-14.336 0-28.444444-7.850667-36.522667-20.593778-7.281778-11.377778-76.117333-123.562667-97.052444-157.696l-1.024-1.592888-7.395556 0.341333c-2.958222 0.227556-5.802667 0.341333-8.874667 0.341333-3.413333 0-6.712889-0.227556-10.012444-0.455111l-6.826667-0.455111-1.024 1.592889c-28.899556 45.738667-90.908444 143.473778-97.848889 153.827555-8.305778 12.401778-22.414222 20.138667-36.750222 20.138667-2.048 0-3.982222 0-5.916444-0.455111a36.977778 36.977778 0 0 1-30.492445-25.827556c-1.137778-3.754667-4.096-12.174222-7.623111-22.414222l-1.137778-3.413333c-11.832889-33.792-20.366222-58.481778-22.641777-69.176889-2.048-7.623111-15.928889-25.6-24.120889-27.989333h-92.728889c-27.761778 0-48.355556-9.671111-56.547556-26.510223-3.072-6.371556-8.533333-23.324444 6.940445-42.780444 33.792-43.235556 67.356444-86.584889 100.920889-129.934222l1.251555-1.592889-0.910222-1.820445a314.936889 314.936889 0 0 1-33.678222-142.108444C196.039111 245.76 339.285333 102.4 515.413333 102.4s319.374222 143.36 319.374223 319.488c0 51.086222-12.629333 102.172444-36.295112 147.456l-1.024 1.820444 1.251556 1.592889c32.085333 42.780444 64.056889 85.333333 96.256 128 15.132444 19.911111 9.443556 36.750222 6.371556 43.121778-8.192 16.611556-28.444444 26.168889-55.296 26.168889h-89.315556c-8.988444 3.754667-21.731556 20.593778-23.552 28.103111-2.161778 10.581333-10.467556 35.498667-21.959111 69.518222-4.209778 12.288-7.509333 22.072889-8.647111 26.168889a36.408889 36.408889 0 0 1-30.378667 26.055111c-2.048 0.455111-3.982222 0.568889-5.802667 0.568889z m101.376-303.331555c-44.828444 58.026667-108.771556 99.100444-180.224 115.712l-4.437334 1.024 2.389334 3.868444c24.462222 39.936 49.038222 79.872 73.614222 119.808l3.640889 5.916445 3.754666-11.036445c6.940444-20.593778 18.659556-55.182222 20.593778-64.056889 4.892444-23.210667 34.588444-65.649778 68.380445-65.649778h97.052444l-82.033778-108.999111-2.616889 3.413334z m-596.536889 102.4h100.124444c34.360889 0 64.625778 42.211556 69.632 65.194666 1.934222 8.760889 13.198222 41.073778 20.707556 62.577778l4.778666 13.539556 3.640889-5.802667c24.917333-39.025778 49.720889-78.165333 74.638223-117.304889l2.503111-3.982222-4.551111-1.137778a319.260444 319.260444 0 0 1-182.840889-120.376889l-2.503111-3.413333-86.016 110.592z m344.405333-569.799111c-150.072889 0-272.156444 122.197333-272.156444 272.270222s122.083556 272.384 272.156444 272.384 272.156444-122.197333 272.156445-272.384S665.6 149.731556 515.527111 149.731556z m0 0"
                  fill="#56B275" p-id="1978"></path>
                <path
                  d="M515.527111 597.902222c-97.052444 0-175.900444-78.961778-175.900444-176.014222s78.848-176.014222 175.900444-176.014222 175.900444 78.961778 175.900445 176.014222-78.961778 176.014222-175.900445 176.014222z m0-304.810666c-70.997333 0-128.796444 57.799111-128.796444 128.796444S444.529778 550.684444 515.527111 550.684444s128.796444-57.799111 128.796445-128.796444-57.799111-128.796444-128.796445-128.796444z m0 0"
                  fill="#56B275" p-id="1979"></path>
              </svg>
              <p>荣誉资质</p>
              <p>Honor Qualification</p>
            </div>
          </div>
          <div style="display: flex;flex-direction: column;width: 100%;height: 100%;">
            <!-- @click="goAboutUs" -->
            <div class="fourpic">
              <svg t="1753432624425" class="icon" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="1743" width="52" height="52">
                <path
                  d="M972.8 826.823111h-921.6V308.792889L512 131.527111l460.8 177.265778v518.030222z m-887.466667-34.133333h853.333334V332.231111L512 168.049778 85.333333 332.231111v460.458667z"
                  fill="#56B275" p-id="1744"></path>
                <path
                  d="M881.777778 474.112h-739.555556v-136.533333h739.555556v136.533333z m-705.422222-34.133333h671.288888v-68.266667h-671.288888v68.266667zM671.288889 826.823111H352.711111v-233.244444h318.577778v233.244444z m-284.444445-34.133333h250.311112v-164.977778H386.844444v164.977778z"
                  fill="#56B275" p-id="1745"></path>
                <path
                  d="M290.133333 348.956444h34.133334v113.777778h-34.133334zM426.666667 348.956444h34.133333v113.777778h-34.133333zM563.2 348.956444h34.133333v113.777778h-34.133333zM699.733333 348.956444h34.133334v113.777778h-34.133334zM506.311111 610.645333h34.133333v193.422223h-34.133333z"
                  fill="#56B275" p-id="1746"></path>
                <path
                  d="M133.688889 522.467556m-14.222222 0a14.222222 14.222222 0 1 0 28.444444 0 14.222222 14.222222 0 1 0-28.444444 0Z"
                  fill="#56B275" p-id="1747"></path>
                <path
                  d="M133.688889 579.356444m-14.222222 0a14.222222 14.222222 0 1 0 28.444444 0 14.222222 14.222222 0 1 0-28.444444 0Z"
                  fill="#56B275" p-id="1748"></path>
                <path
                  d="M133.688889 636.245333m-14.222222 0a14.222222 14.222222 0 1 0 28.444444 0 14.222222 14.222222 0 1 0-28.444444 0Z"
                  fill="#56B275" p-id="1749"></path>
                <path
                  d="M133.688889 693.134222m-14.222222 0a14.222222 14.222222 0 1 0 28.444444 0 14.222222 14.222222 0 1 0-28.444444 0Z"
                  fill="#56B275" p-id="1750"></path>
                <path
                  d="M133.688889 750.023111m-14.222222 0a14.222222 14.222222 0 1 0 28.444444 0 14.222222 14.222222 0 1 0-28.444444 0Z"
                  fill="#56B275" p-id="1751"></path>
                <path
                  d="M190.577778 579.356444m-14.222222 0a14.222222 14.222222 0 1 0 28.444444 0 14.222222 14.222222 0 1 0-28.444444 0Z"
                  fill="#56B275" p-id="1752"></path>
                <path
                  d="M190.577778 636.245333m-14.222222 0a14.222222 14.222222 0 1 0 28.444444 0 14.222222 14.222222 0 1 0-28.444444 0Z"
                  fill="#56B275" p-id="1753"></path>
                <path
                  d="M190.577778 693.134222m-14.222222 0a14.222222 14.222222 0 1 0 28.444444 0 14.222222 14.222222 0 1 0-28.444444 0Z"
                  fill="#56B275" p-id="1754"></path>
                <path
                  d="M190.577778 750.023111m-14.222222 0a14.222222 14.222222 0 1 0 28.444444 0 14.222222 14.222222 0 1 0-28.444444 0Z"
                  fill="#56B275" p-id="1755"></path>
                <path
                  d="M247.466667 636.245333m-14.222223 0a14.222222 14.222222 0 1 0 28.444445 0 14.222222 14.222222 0 1 0-28.444445 0Z"
                  fill="#56B275" p-id="1756"></path>
                <path
                  d="M247.466667 693.134222m-14.222223 0a14.222222 14.222222 0 1 0 28.444445 0 14.222222 14.222222 0 1 0-28.444445 0Z"
                  fill="#56B275" p-id="1757"></path>
                <path
                  d="M247.466667 750.023111m-14.222223 0a14.222222 14.222222 0 1 0 28.444445 0 14.222222 14.222222 0 1 0-28.444445 0Z"
                  fill="#56B275" p-id="1758"></path>
                <path
                  d="M304.355556 693.134222m-14.222223 0a14.222222 14.222222 0 1 0 28.444445 0 14.222222 14.222222 0 1 0-28.444445 0Z"
                  fill="#56B275" p-id="1759"></path>
                <path
                  d="M304.355556 750.023111m-14.222223 0a14.222222 14.222222 0 1 0 28.444445 0 14.222222 14.222222 0 1 0-28.444445 0Z"
                  fill="#56B275" p-id="1760"></path>
                <path
                  d="M907.377778 522.467556m-14.222222 0a14.222222 14.222222 0 1 0 28.444444 0 14.222222 14.222222 0 1 0-28.444444 0Z"
                  fill="#56B275" p-id="1761"></path>
                <path
                  d="M907.377778 579.356444m-14.222222 0a14.222222 14.222222 0 1 0 28.444444 0 14.222222 14.222222 0 1 0-28.444444 0Z"
                  fill="#56B275" p-id="1762"></path>
                <path
                  d="M907.377778 636.245333m-14.222222 0a14.222222 14.222222 0 1 0 28.444444 0 14.222222 14.222222 0 1 0-28.444444 0Z"
                  fill="#56B275" p-id="1763"></path>
                <path
                  d="M907.377778 693.134222m-14.222222 0a14.222222 14.222222 0 1 0 28.444444 0 14.222222 14.222222 0 1 0-28.444444 0Z"
                  fill="#56B275" p-id="1764"></path>
                <path
                  d="M907.377778 750.023111m-14.222222 0a14.222222 14.222222 0 1 0 28.444444 0 14.222222 14.222222 0 1 0-28.444444 0Z"
                  fill="#56B275" p-id="1765"></path>
                <path
                  d="M850.488889 579.356444m-14.222222 0a14.222222 14.222222 0 1 0 28.444444 0 14.222222 14.222222 0 1 0-28.444444 0Z"
                  fill="#56B275" p-id="1766"></path>
                <path
                  d="M850.488889 636.245333m-14.222222 0a14.222222 14.222222 0 1 0 28.444444 0 14.222222 14.222222 0 1 0-28.444444 0Z"
                  fill="#56B275" p-id="1767"></path>
                <path
                  d="M850.488889 693.134222m-14.222222 0a14.222222 14.222222 0 1 0 28.444444 0 14.222222 14.222222 0 1 0-28.444444 0Z"
                  fill="#56B275" p-id="1768"></path>
                <path
                  d="M850.488889 750.023111m-14.222222 0a14.222222 14.222222 0 1 0 28.444444 0 14.222222 14.222222 0 1 0-28.444444 0Z"
                  fill="#56B275" p-id="1769"></path>
                <path
                  d="M793.6 636.245333m-14.222222 0a14.222222 14.222222 0 1 0 28.444444 0 14.222222 14.222222 0 1 0-28.444444 0Z"
                  fill="#56B275" p-id="1770"></path>
                <path
                  d="M793.6 693.134222m-14.222222 0a14.222222 14.222222 0 1 0 28.444444 0 14.222222 14.222222 0 1 0-28.444444 0Z"
                  fill="#56B275" p-id="1771"></path>
                <path
                  d="M793.6 750.023111m-14.222222 0a14.222222 14.222222 0 1 0 28.444444 0 14.222222 14.222222 0 1 0-28.444444 0Z"
                  fill="#56B275" p-id="1772"></path>
                <path
                  d="M736.711111 693.134222m-14.222222 0a14.222222 14.222222 0 1 0 28.444444 0 14.222222 14.222222 0 1 0-28.444444 0Z"
                  fill="#56B275" p-id="1773"></path>
                <path
                  d="M736.711111 750.023111m-14.222222 0a14.222222 14.222222 0 1 0 28.444444 0 14.222222 14.222222 0 1 0-28.444444 0Z"
                  fill="#56B275" p-id="1774"></path>
                <path d="M51.2 857.088h921.6v34.133333h-921.6z" fill="#56B275" p-id="1775"></path>
              </svg>
              <p>生产工艺</p>
              <p>Production process</p>
            </div>
            <div class="fourpic">
              <svg t="1753432700681" class="icon" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="2181" width="52" height="52">
                <path
                  d="M537.031111 460.003556H278.528a25.929956 25.929956 0 1 1 0-51.882667H537.031111a25.929956 25.929956 0 1 1 0 51.882667z m0-103.992889H278.528a25.929956 25.929956 0 1 1 0-51.882667H537.031111a25.929956 25.929956 0 1 1 0 51.882667z m0 0"
                  fill="#56B275" p-id="2182"></path>
                <path
                  d="M796.103111 875.064889H226.986667c-43.121778 0-78.165333-35.043556-78.165334-78.165333V227.783111c0-43.121778 35.043556-78.165333 78.165334-78.165333h362.496a25.929956 25.929956 0 1 1 0 51.882666H226.986667c-14.449778 0-26.282667 11.832889-26.282667 26.282667v569.002667c0 14.449778 11.832889 26.282667 26.282667 26.282666h569.002666c14.449778 0 26.282667-11.832889 26.282667-26.282666V175.900444a25.929956 25.929956 0 1 1 51.882667 0v620.885334c0 43.121778-35.043556 78.279111-78.165334 78.279111z m0 0"
                  fill="#56B275" p-id="2183"></path>
                <path
                  d="M720.896 147.797333c-14.336 0-25.941333 11.605333-25.941333 25.941334v399.132444l25.941333 42.325333 25.941333-42.211555V173.738667c0-14.336-11.605333-25.941333-25.941333-25.941334z m0 0"
                  fill="#56B275" p-id="2184"></path>
                <path
                  d="M355.783111 718.961778c0 28.672 23.210667 51.882667 51.996445 51.882666s51.882667-23.210667 51.882666-51.882666-23.210667-51.882667-51.882666-51.882667-51.996444 23.210667-51.996445 51.882667z m0 0M509.952 718.961778c0 28.672 23.210667 51.882667 51.882667 51.882666s51.996444-23.210667 51.996444-51.882666-23.210667-51.882667-51.996444-51.882667-51.882667 23.210667-51.882667 51.882667z m0 0M666.624 718.961778c0 28.672 23.210667 51.882667 51.882667 51.882666s51.882667-23.210667 51.882666-51.882666-23.210667-51.882667-51.882666-51.882667-51.882667 23.210667-51.882667 51.882667z m0 0"
                  fill="#56B275" p-id="2185"></path>
              </svg>
              <p>工程案例</p>
              <p>Engineering case</p>
            </div>
          </div>
        </div>
      </div>
      <!-- 新闻 -->
      <div class="last_content">
        <div class="last_one">
          <div class="blue_piece"></div>
          {{ $t("user.News") }}
        </div>
        <div class="last_two">
          <span>{{ $t("user.focusUpdate") }}</span>
        </div>
        <div class="heng_line"></div>
        <div class="news_box">
          <div v-loading="isLoading1" element-loading-text="加载中，请稍候..." element-loading-spinner-color="#56B275"
            element-loading-background="rgba(255, 255, 255, 0.8)" style="position: relative;">
            <el-row :gutter="10" class="news_boxel">
              <!-- 新闻图片 -->

              <el-col :xs="24" :sm="12" class="news_left">
                <div class="block">
                  <el-carousel>

                    <el-carousel-item v-for="item in newsList.slice(0, 3)" :key="item.id">
                      <div @click="goDetail(item)" class="botMsg">
                        <span>{{ item.title }}</span>
                      </div>
                      <img :src="item.url" alt="" />
                    </el-carousel-item>

                  </el-carousel>
                </div>
              </el-col>
              <!-- 新闻文字 -->
              <el-col :xs="0" :sm="12" class="news_right">
                <div class="newsr_box">
                  <!-- 使用 v-for 循环渲染新闻条目 -->
                  <div class="newsrb_item" v-for="(newsItem, index) in newsList.slice(0, 3)" :key="index"
                    @click="goDetail(newsItem)">
                    <div class="ni_left">
                      <span>{{ getDay(newsItem.createTime) }}</span>
                      <div>{{ getDateStr(newsItem.createTime) }}</div>
                    </div>
                    <div class="ni_right">
                      <p>{{ newsItem.title }}</p>
                      <div v-html="processContent(newsItem.content)"></div>
                    </div>
                  </div>
                </div>
              </el-col>

            </el-row>
          </div>
        </div>
      </div>
    </div>
    <div class="image-preview-modal" v-if="isPreviewOpen" @click="closePreview">
      <div class="preview-content" @click.stop>
        <button class="close-btn" @click="closePreview">×</button>
        <img :src="currentPreviewImage" alt="预览图片" class="preview-image"
          :style="{ maxHeight: `${maxPreviewHeight}px`, transform: `scale(${scale})`, transition: 'transform 0.2s ease' }">
      </div>
    </div>

  </div>
</template>

<script>
import { getSeries, getProduct, getnews } from "@/api";

export default {
  data() {
    return {
      isLoading1: false,
      isLoading: false,
      isMobile: this.$store.state.isMobile,
      // 保存定时器引用
      timer: null,
      count: 0,
      count2: 0,
      count3: 0,
      isCounting: false, // 防止多次计数
      hasScrolledIntoView: false,
      newData: [],
      newsList: [],
      bannerList: [
      ],
      newsSwipper: [
        // {
        //   id: 0,
        //   url: require("@/assets/furuiImg/3news.png"),
        //   msg: "技术研发交流大会",
        // },
        // {
        //   id: 1,
        //   url: require("@/assets/furuiImg/3news.png"),
        //   msg: "二次技术交流大会",
        // },
        // {
        //   id: 2,
        //   url: require("@/assets/furuiImg/3news.png"),
        //   msg: "三次技术交流大会",
        // },
        // {
        //   id: 3,
        //   url: require("@/assets/furuiImg/3news.png"),
        //   msg: "交流大会",
        // },
      ],
      activeIndex: 0, // 默认选中第一个选项
      // 存储选项数据，与国际化对应
      items: [
        { name: this.$t("user.work1") },
        { name: this.$t("user.work2") },
        { name: this.$t("user.work3") },
        { name: this.$t("user.work4") },
        { name: this.$t("user.work5") },
        { name: this.$t("user.work6") },
        { name: this.$t("user.work7") }
      ],
      imageRows: [
        // 第一行
        [
          { src: require('@/assets/picture/1.png') },
          { src: require('@/assets/picture/2.png') }
        ],
        // 第二行
        [
          { src: require('@/assets/picture/3.png') },
          { src: require('@/assets/picture/6.png') }
        ],
        // 第三行
        [
          { src: require('@/assets/picture/5.png') },
          { src: require('@/assets/picture/4.png') }
        ]
      ],
      currentImage: '',
      isPreviewOpen: false,
      currentPreviewImage: '',
      maxPreviewHeight: 0,
      scale: 1, // 缩放比例，初始为1（100%）
      minScale: 0.5, // 最小缩放比例
      maxScale: 3,// 最大缩放比例
      products: [
        // {
        //   title: this.$t("user.product1"),
        //   imageUrl: require("@/assets/picture/产品1.png")
        // },
        // {
        //   title: this.$t("user.product2"),
        //   imageUrl: require("@/assets/picture/产品2.png")
        // },
        // {
        //   title: this.$t("user.product2"),
        //   imageUrl: require("@/assets/picture/产品2.png")
        // },
        // {
        //   title: this.$t("user.product2"),
        //   imageUrl: require("@/assets/picture/产品2.png")
        // },
        // {
        //   title: this.$t("user.product2"),
        //   imageUrl: require("@/assets/picture/产品2.png")
        // },
      ]
    };
  },
  mounted() {
    // console.log(this.isMobile);
    // 组件挂载后添加滚动事件监听器
    window.addEventListener("scroll", this.checkScroll);
    this.getSeries()

    this.newa()
    this.getProduct(this.items[0])
    this.maxPreviewHeight = window.innerHeight * 0.8;
    window.addEventListener('resize', this.handleResize);
    // 初始检查滚动位置

    // swiper 轮播图功能

    // 产品数据
    // this.project();

    // 新闻数据
    // this.newa();
  },
  // computed: {
  //   processedContent() {
  //     if (!this.newsItem?.content) return '';
  //     // 正则匹配并移除所有 <img> 标签（包括其属性和内容）
  //     return this.newsItem.content.replace(/<img[^>]*>/gi, '');
  //   }
  // },
  methods: {
    processContent(content) {
      if (!content) return '';
      // 只移除 img 标签，保留其他内容
      return content.replace(/<img[^>]*>/gi, '');
    },
    handleMore() {
      this.$router.push('/product')
    },
    goAboutUs() {
      this.$router.push('/aboutus')
    },
    goDetail(item) {
      this.$router.push({
        name: 'newDetail',
        params: item
      });
    },
    // 获取产品分类
    getSeries() {
      getSeries().then((res) => {
        console.log(res.data)
        this.items = res.data
      })
    },
    // 产品跳转
    gotoDetail(product) {
      this.$router.push({
        name: 'frProjectDetail',
        params: product
      });
    },
    // 点击事件处理函数
    handleClick(index, item) {
      this.activeIndex = index;
      this.getProduct(item);
      // 可以在这里添加切换选项后的其他逻辑
      // console.log("选中了第", index + 1, "个选项");

      // 如果需要根据选中项触发其他操作，可以调用对应的方法
      // this.doSomething(index);
    },
    newa() {
      this.isLoading1 = true
      getnews({ page: 1, pageSize: 5, type: '公司新闻' })
        .then((res) => {
          this.newsList = res.data
          this.isLoading1 = false
        })
    },
    //获取产品
    getProduct(item) {
      this.isLoading = true
      getProduct({ page: 1, pageSize: 5, type: item.name }).then((res) => {
        this.products = res.data.sort((a, b) => {
          // 将字符串转换为数字后比较
          return Number(b.sort) - Number(a.sort);
        });

        this.isLoading = false
      })
    },
    checkScroll() {
      //数字倒计时显示
      this.$nextTick(() => {
        if (this.$refs.target) {
          const target = this.$refs.target;
          const rect = target.getBoundingClientRect();
          // 判断元素是否在视口内
          if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
            if (!this.hasScrolledIntoView) {
              this.hasScrolledIntoView = true;
              // 这里可以执行其他操作，例如开始动画等
              const target = 15; // 目标数字
              const target2 = 100; // 目标数字
              const target3 = 30; // 目标数字
              let current = this.count;
              let current2 = this.count2;
              let current3 = this.count3;
              const interval = setInterval(() => {
                if (current < target) {
                  current += 1;
                  this.count = current;
                } else {
                  clearInterval(interval);
                }
              }, 100); // 每100毫秒增加1
              const interval2 = setInterval(() => {
                if (current2 < target2) {
                  current2 += 1;
                  this.count2 = current2;
                } else {
                  clearInterval(interval2);
                }
              }, 100); // 每100毫秒增加1

              const interval3 = setInterval(() => {
                if (current3 < target3) {
                  current3 += 1;
                  this.count3 = current3;
                } else {
                  clearInterval(interval3);
                }
              }, 100); // 每100毫秒增加1
            }
          } else {
            if (this.hasScrolledIntoView) {
              this.hasScrolledIntoView = false;
            }
          }
        }
      });
    },
    getDay(timeStr) {
      const date = new Date(timeStr);
      return date.getDate().toString().padStart(2, '0');
      // padStart 确保是两位数，比如 5 → '05'
    },
    // 获取“年-月-日”
    getDateStr(timeStr) {
      const date = new Date(timeStr);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      // 月份是 0-11，所以 +1
      const day = date.getDate().toString().padStart(2, '0');
      return `${year}-${month}`;
    },
    // 打开图片预览弹窗
    openImage(imageUrl) {
      this.currentPreviewImage = imageUrl;
      console.log('aa', this.currentPreviewImage)
      this.isPreviewOpen = true;
      this.scale = 1;
      // 禁止页面滚动
      document.body.style.overflow = 'hidden';
      document.addEventListener('wheel', this.handleWheel);
    },
    // 处理鼠标滚轮缩放
    closePreview() {
      this.isPreviewOpen = false;
      this.currentPreviewImage = '';
      // 恢复页面滚动
      document.body.style.overflow = '';
      document.removeEventListener('wheel', this.handleWheel);
    },
    // 处理鼠标滚轮事件
    handleWheel(e) {
      e.preventDefault(); // 阻止事件冒泡和默认行为

      // 判断滚轮方向：deltaY为正向下滚（缩小），为负向上滚（放大）
      const delta = e.deltaY > 0 ? -0.1 : 0.1;
      let newScale = this.scale + delta;

      // 限制缩放范围在minScale和maxScale之间
      newScale = Math.max(this.minScale, Math.min(newScale, this.maxScale));

      // 更新缩放比例
      this.scale = newScale;
    },
    // 重置缩放比例为原始大小
    resetZoom() {
      this.scale = 1;
    },
    handleResize() {
      this.maxPreviewHeight = window.innerHeight * 0.8;
    },
  },
  beforeDestroy() {
    // 在组件销毁之前停止观察器
    // if (this.observer) {
    // this.items.forEach((item, index) => {
    // const target = this.$refs['box' + index][0];
    // this.observer.unobserve(target);
    // });
    // }
    // 组件销毁前清除定时器
    if (this.timer) {
      clearInterval(this.timer);
    }
    window.removeEventListener('resize', this.handleResize);
  },

};
</script>
<style scoped lang="scss">
::v-deep .el-loading-spinner .circular .path {
  stroke: #56B275 !important;
  /* 圈圈的边框颜色 */
}

/* 若加载文字也需要改颜色，可添加以下代码 */
::v-deep .el-loading-text {
  color: #56B275 !important;
  writing-mode: horizontal-tb;
  /* 加载文字颜色 */
}

// 图片预览弹窗样式
.image-preview-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
  opacity: 0;
  animation: fadeIn 0.3s ease forwards;
}

.preview-content {
  position: relative;
  max-width: 100%;
}

.preview-image {
  max-width: 100%;
  object-fit: contain;
  cursor: zoom-in;
  transition: transform 0.3s ease;
}

// 关闭按钮样式
.close-btn {
  position: absolute;
  top: -40px;
  right: -40px;
  background: none;
  border: none;
  color: white;
  font-size: 30px;
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.8;
  transition: all 0.2s;

  &:hover {
    opacity: 1;
    transform: scale(1.1);
  }
}

// 淡入动画
@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.el-dialog__body {
  padding: 20px 0 !important;
  /* 去掉默认内边距，让图片更居中 */
}

.el-carousel__container {}

.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}

@media (max-width: 768px) {
  .head_box {
    height: 270px !important;
  }
}

.product_card {
  height: 28vw;
  // height: 500px;
  border: 1px solid #F4F4F4;
  width: 17vw;
  // width: 300px;
  margin-top: 0px;
  padding-left: 30px;
  padding-top:
    30px;
  border-radius: 50px;
  padding-right: 30px;
  justify-content: center;
  align-items: center;
  transition: transform 0.3s ease;
  padding-bottom: 10px;
}

.product_card:hover .product_btn {
  // color: pink;
  transform: scale(1.2);
  background-color: #56B275;
  color: white;
}

.product_card:hover {
  // color: pink;
  transform: scale(1.1);
  // background-color: #1A96D2;
  // color: white;
}

.product_btn {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 30px;
  background-color: #f1f1f1;
  width: 6vw;
  height: 2vw;
  // color: #f3f3f3;
  margin: auto;
  margin-top: 1vw;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.more {
  margin-top: 10px;
  margin-right: 10px;
  width: 100px;
  height: 50px;
  text-align: center;
  padding: 15px;
  // border: 1px solid #1A96D4;
  background-color: #F1F1F1;
  border-radius: 10px;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.more:hover {
  color: white;
  transform: scale(1.1);
  background-color: #56B275;
}

::v-deep .el-carousel__container {
  //height: 100%;
  height: 23vw;
}

.fourpic {
  width: 100%;
  background-color: white;
  height: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 2vw;
  border: 1px solid #f4f4f4;
  color: #56B275;
  transition: transform 0.3s ease, ;
  cursor: pointer;
}

.fourpic:hover {
  background-color: #56B275;
  color: white;

}

.fourpic p,
.fourpic svg {
  transition: transform 0.3s ease;
  /* 子元素添加过渡，确保移动平滑 */
}

.fourpic:hover p,
.fourpic:hover svg {
  transform: translateY(-5px);
}

.fourpic:hover svg path {
  fill: white;
}

.product_p1 {
  height: 0.5vw;
  background-color: #56B275;
  width: 100%;
  margin-top: 10px;
}

.product_p2 {
  height: 4px;
  background-color: #56B275;
  width: 100%;
  margin-bottom: 10px;
  margin-top: 3px;
}

.head_box {
  // width: 100%;
  // background: url(../assets/furuiImg/banner.jpg);
  height: 520px;
  // height: 700px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  margin-top: 80px;
}

.blue_piece {
  height: 11px;
  width: 5px;
  background-color: #56B275;
  margin-right: 10px;
}

.heng_line {
  width: 100%;
  height: 1px;
  background-color: rgb(181, 181, 181);
  margin: 20px 0;
}

.about_two {
  font-size: 30px;
  font: black;
  margin-bottom: 20px;
}

.aboutFurui {
  width: 80vw;
  margin: 200px auto;

  .about_one {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 20px;
    margin-bottom: 20px;
  }



  .about_three {
    width: 100%;
    height: 1px;
    margin: 30px auto;
    background-color: rgb(167, 165, 165);
  }

  .about_four {
    line-height: 3;
    text-indent: 4ch;
  }
}

.home_three {
  width: 100%;
  background: url(../assets/furuiImg/background.png);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  // padding: 50px 0;

  .three_content {
    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    // @media (max-width: 768px) {
    //   .ht_left {
    //     font-size: 3px;
    //   }
    // }

    .ht_left {
      width: 40vw;
      // width: 500px;
      margin-top: -10px;
      font-size: 20px;
      text-align: left;

      .start_year {
        margin-bottom: 20px;
      }

      .es_font {
        color: #56B275;
        font-size: 36px;
      }
    }

    .ht_right {
      display: flex;
      justify-content: end;
      margin-top: -30px;
      margin-bottom: 50px;
    }
  }
}

.home_last {
  width: 100%;
  margin-top: 50px;
  margin-bottom: 80px;

  .last_content {
    // width: 90vw;
    // height: 30vw;
    // margin: 0 auto;
    padding: 0 3vw;

    .last_one {
      display: flex;
      flex-direction: row;
      align-items: center;
      font-size: 20px;
    }

    .last_two {
      >span {
        padding: 10px 30px 10px 0;
        font-size: 32px;
        font-weight: 400;
        background-image: linear-gradient(to right,
            rgba(255, 255, 255, 1),
            rgba(255, 255, 255, 1) 50%,
            rgba(255, 255, 255, 0) 50%,
            rgba(255, 255, 255, 0)),
          radial-gradient(circle at 25% 50%,
            rgba(0, 0, 0, 0.2) 10%,
            rgba(0, 0, 0, 0) 11%),
          radial-gradient(circle at 75% 50%,
            rgba(0, 0, 0, 0.2) 10%,
            rgba(0, 0, 0, 0) 11%);
        background-size: 8px 8px;
        background-position: 0 0, 0 0;
        background-repeat: repeat;
      }
    }

    .news_box {
      .news_boxel {
        display: flex;
        justify-content: space-between;
        flex-direction: row;
      }

      .news_left {

        // margin-right: 30px;
        .block {
          width: 100%;
          height: 100%;
          position: relative;

          .botMsg {
            position: absolute;
            bottom: 0;
            background: #565454;
            opacity: 0.7;
            color: white;
            width: 100%;
            height: 50px;
            line-height: 50px;
            overflow: hidden;
            white-space: nowrap;
            text-indent: 2ch;
            cursor: pointer;
          }

          img {
            width: 100%;
            height: 100%;
            object-fit: fit;
          }
        }
      }

      .news_right {
        .newsr_box {
          width: 100%;

          .newsrb_item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 90px;
            width: 100%;
            margin-bottom: 3vw;
            cursor: pointer;

            .ni_left {
              height: 100%;
              background: #56B275;
              display: flex;
              justify-content: center;
              align-items: center;
              flex-direction: column;
              color: white;
              margin-right: 10px;
              padding: 0 20px;

              >span {
                font-size: 30px;
                font-weight: bold;
                line-height: 1;
              }

              >div {
                white-space: nowrap;
              }
            }

            .ni_right {
              >p {
                font-size: 16px;
                color: #56B275;
                margin-bottom: 10px;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
              }

              >div {
                font-size: 12px;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
          }
        }
      }
    }
  }
}
</style>